import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import {
  alertPresets,
  AlertService,
  ToastTypes,
} from 'src/app/shared/services/alert.service';
import { SweetAlertOptions } from 'sweetalert2';
import { OpTypes } from '../state/_models/general.model';
import { OpTypes as AppUserOpTypes } from '../state/_models/application-users.model';
export interface Extra {
  success: {
    show: boolean;
    message: string;
    title: string;
    showSwal: boolean;
    showResponseSuccess?: boolean;
    alertOptions: SweetAlertOptions;
  };
  error: {
    show: boolean;
    message?: string;
    title: string;
    showResponseError: boolean;
  };
}

export const defaultExtra: Extra = {
  success: {
    show: true,
    message: 'Your changes have been saved',
    title: 'Saved',
    showSwal: false,
    showResponseSuccess: false,
    alertOptions: <SweetAlertOptions>alertPresets.saveSuccess,
  },
  error: {
    show: true,
    title: 'Error',
    showResponseError: true, // show error comming in response
  },
};

@Injectable({
  providedIn: 'root',
})
export class ActionService {
  constructor(private alert: AlertService, private store: Store) {}

  /**
   * Dispatch an action
   * @param action action needs to dispatch
   * @param selector operations selector
   */
  dispatch = (
    opType: OpTypes | AppUserOpTypes,
    action: any,
    opSelector: any,
    extra: Extra = defaultExtra
  ) => {
    return new Promise<any>((resolve, reject) => {
      const uid = crypto.randomUUID();
      action.refId = uid;
      this.store.dispatch(action);
      this.store
        .pipe(
          select(opSelector),
          filter(
            (object: any) =>
              object[uid] &&
              (object[uid].type === opType ||
                object[uid].type === OpTypes.FAILED)
          )
        )
        .pipe(take(1))
        .subscribe((object) => {
          if (object[uid].type === opType) {
            if (extra.success.show)
              if (extra.success.showSwal) {
                this.alert.fire(extra.success.alertOptions);
              } else
                this.alert.toast(
                  ToastTypes.SUCCESS,
                  extra.success.title,
                  extra.success.showResponseSuccess 
                  ? object[uid].payload
                  : extra.success.message
                );
            resolve(object[uid]);
          } else {
            if (extra.error.show)
              this.alert.toast(
                ToastTypes.ERROR,
                extra.error.title,
                extra.error.showResponseError
                  ? this.errorResponseMessage(object[uid].error.error)
                  : extra.error.message || 'An unexpected error occurred'
              );
            reject();
          }
        });
    });
  }

  /**
   * @returns error message to be shown
   */
  errorResponseMessage = (response: any): string => {
    if (typeof response === 'string') return response;
    if (response?.Message) return response.Message;
    if (response?.message) return response.message;
    if (response?.title) return response.title;
    if (response?.Errors?.length) return response.Errors.join(', ');
    if (response?.errors) {
      const msgs = Object.values(response.errors).flat();
      if (msgs.length) return msgs.join(', ');
    }
    return 'An unexpected error occurred';
  };
}
